import React, { useState } from 'react';

function FinancesTransactionSelectionTable({ transactions, matchUrl, getData}) {
  const [quantitySelected, setQuantitySelected] = useState(0);

  const updateTransactions = async () => {
    try {
      clearCheckBoxes();
      setQuantitySelected(0);
      disableAllButtons();
      getData();
      enableAllButtons();
    } catch (error) {
      console.error(error);
    }
  };

  const disableAllButtons = () => {
    const buttons = document.querySelectorAll('button');
    buttons.forEach((button) => { button.disabled = true; });
  };

  const enableAllButtons = () => {
    const buttons = document.querySelectorAll('button');
    buttons.forEach((button) => { button.disabled = false; });
  };

  const clearCheckBoxes = () => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => { checkbox.checked = false; });
  };

  function handleCheckboxQuantityChange(event, quantity) {
    const isChecked = event.target.checked;
    if (isChecked)
      setQuantitySelected(quantitySelected + quantity);
    else
      setQuantitySelected(quantitySelected - quantity);
  }

  const handleActionOnTransactions = async (action) => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');

    const transactionIds = [];
    checkboxes.forEach((checkbox) => { transactionIds.push(checkbox.id); });

    fetch(action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(transactionIds),
    })
      .then(response => {
        if (!response.ok) {
          if (response.status === 400) {
            return response.json().then(errorData => {
              throw new Error(JSON.stringify(errorData.errors));
            });
          } else {
            throw new Error('Failed: ' + response.statusText);
          }
        }
        updateTransactions();
      })
      .catch(error => {
        console.error('Error with matchtransactions:', error);
      });

    await updateTransactions();
  }

  const handleMatchTransactionsButtonClick = async () => {
    await handleActionOnTransactions(matchUrl);
  }

  const handleIgnoreTransactionsButtonClick = async () => {
    await handleActionOnTransactions('api/finances/ignoretransactions');
  }

  const handleRevertToOriginButtonClick = async () => {
    await handleActionOnTransactions('api/finances/reverttoorigin');
  }

  return (
    <div>
      <h5>Quantity Selected: {quantitySelected}</h5>
      <button onClick={handleIgnoreTransactionsButtonClick} style={{ margin: 5 }}>Ignore</button>
      <button onClick={handleRevertToOriginButtonClick}>Revert to Origin</button>
      <table className="table" style={{ flex: 1 }}>
        <thead className="thead-dark">
          <tr>
            <th>Moved</th>
            <th>Id</th>
            <th>Date</th>
            <th>Account</th>
            <th>Type</th>
            <th>Symbol</th>
            <th>Quantity</th>
            <th>PriceUSD</th>
            <th>CryptoFee</th>
            <th>Cost Basis</th>
            <th>Match</th>
            <th></th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index2) => {
            const unmatchedWithdrawal = transaction.type === "WITHDRAWAL";
            const unmatchedSale = transaction.type === "SELL";
            const unmatchedDeposit = transaction.type === "DEPOSIT";
            const needsMatching = unmatchedSale || unmatchedWithdrawal || unmatchedDeposit;
            const backgroundColor =
              (unmatchedWithdrawal ? 'lightcoral' :
                (unmatchedSale ? 'lightyellow' :
                  (unmatchedDeposit ? 'lightgreen' : 'inherit')));
            return (
              <>
                <tr key={transaction.id} style={{
                  backgroundColor: backgroundColor,
                  fontWeight: needsMatching ? 'bold' : 'normal'
                }}>
                  <td>{(transaction.transferredLotId != null ? '*' : ' ')}</td>
                  <td>{transaction.id}</td>
                  <td>
                    {new Date(transaction.date).toLocaleDateString('en-US', { dateStyle: 'short' })}
                    <br />
                    {new Date(transaction.date).toLocaleTimeString('en-US', { timeStyle: 'short' })}
                  </td>
                  <td><div title={transaction.account.id.toString()}>{transaction.account.friendlyName}</div></td>
                  <td>{transaction.type + '-' + transaction.subtype}</td>
                  <td>{transaction.symbol}</td>
                  <td><input type="checkbox"
                    id={(transaction.transferredLotId == null ? transaction.id : "T" + transaction.transferredLotId)}
                    onChange={(event) => handleCheckboxQuantityChange(event, transaction.quantity)}
                    style={{ marginRight: 10 }} />{transaction.quantity}
                    <br></br>
                    {transaction.fullQuantity !== transaction.quantity && "(" + transaction.fullQuantity + ")"}
                  </td>
                  <td>{
                    transaction.quantity !== 0 ?
                      Math.abs(transaction.costBasis / transaction.quantity).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) :
                      Math.abs(transaction.costBasis / transaction.fullQuantity).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                  }</td>
                  <td>{transaction.cryptoFee}</td>
                  <td>{transaction.costBasis}<br></br>{transaction.fullCostBasis !== transaction.costBasis && "(" + transaction.fullCostBasis + ")"}</td>
                  <td>
                    <div>
                      <p>{quantitySelected}</p>
                    </div>
                  </td>
                  <td>
                    <button onClick={handleMatchTransactionsButtonClick}>Match</button>
                  </td>
                  <td>{transaction.notes}</td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default FinancesTransactionSelectionTable;